export function getCSSVar(variable: string) {
  return `var(${variable})`;
}
